import { Backdrop, CircularProgress } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "@progress/kendo-font-icons/dist/index.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router";
import MainLayout from "./components/layout/MainLayout";
import APIErrorProvider from "./context/ApiErrorContext";
import MenuHeader from "./header/MenuHeader";
import Connection from "./pages/connection/Connection";
import Loading from "./pages/loading/Loading";
import CustomNavigation from "./pages/navigation/customNavigation";
import AlertMessage from "./pages/planogramme/components/AlertMessage";
import MutationHandler from "./pages/planogramme/components/MutationHandler";
import { setToken, setUser } from "./redux/features/appStateSlice";
import {
  planoAPI
} from "./redux/features/cache";
import { useAppDispatch } from "./redux/store";
import { routes } from "./routes";

function App() {
  const dispatch = useAppDispatch();

  const [loginWithToken] = planoAPI.endpoints.loginWithToken.useLazyQuery();

  const [urlLoaded, setUrlLoaded] = useState(false);

  useEffect(() => {
    let getUrlInfos = async () => {
      var search = new URLSearchParams(window.location.href.split("?")[1]);
      if (search.get("applicatauthtoken") !== null) {
        let token = search.get("applicatauthtoken");
        let user = await loginWithToken(token!).unwrap();
        if (user.success) {
          localStorage.setItem("token", user.token);
          localStorage.setItem("user", user.user);
          dispatch(setToken(user.token));
          dispatch(setUser(user.user));
        } else {
          localStorage.clear();
        }
        window.history.replaceState(
          null,
          "",
          window.location.href.split("?")[0]
        );
      } else if (search.get("token") !== null && search.get("user") !== null) {
        let token = search.get("token");
        localStorage.setItem("token", `Bearer ${search.get("token")}`);
        localStorage.setItem("user", `${search.get("user")}`);
        dispatch(setToken(`Bearer ${token}`));
        dispatch(setUser(search.get("user")!));
        window.history.replaceState(
          null,
          "",
          window.location.href.split("?")[0]
        );
      }
      setUrlLoaded(true);
    };
    getUrlInfos();
  }, []);

  return urlLoaded ? (
    <BrowserRouter>
      <CustomNavigation>
        <Loading>
          <Connection>
            <AlertMessage>
              <MutationHandler>
                <APIErrorProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MenuHeader>
                      <Routes>
                        <Route path="/" element={<MainLayout />}>
                          {routes}
                        </Route>
                      </Routes>
                    </MenuHeader>
                  </LocalizationProvider>
                </APIErrorProvider>
              </MutationHandler>
            </AlertMessage>
          </Connection>
        </Loading>
      </CustomNavigation>
    </BrowserRouter>
  ) : (
    <Backdrop sx={{ color: "#fff", zIndex: 2147483647 }} open={true}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
export default App;
